import { formatDate, formatDateTimePrecise } from '@seen/core/dates'

import { cn, TypographyDetail } from '@seen/ui'
import type { ReactNode } from 'react'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'

export function HoverCreatedOn({
  createdOn,
  className,
}: {
  createdOn: string
  className?: string
}): ReactNode {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <TypographyDetail
          className={cn(
            'select-none font-normal text-foreground-secondary',
            className
          )}
        >
          {formatDate(createdOn)}
        </TypographyDetail>
      </TooltipTrigger>
      <TooltipContent>
        Created {formatDateTimePrecise(createdOn)}
      </TooltipContent>
    </Tooltip>
  )
}
